<div class="row mb-4">
  <!-- Label Column -->
  <label
    [class]="labelColClass + ' form-label'"
    [class.required]="config.required"
    [attr.for]="formControlName"
  >
    {{ config.label | translate }}
  </label>

  <!-- Input Column -->
  <div [class]="inputColClass">
    <!-- TEXT, PASSWORD, EMAIL, NUMBER, URL, TEL -->
    <input
      *ngIf="
        ['text', 'password', 'email', 'number', 'url', 'tel'].includes(
          config.type
        )
      "
      [type]="config.type"
      [id]="formControlName"
      [placeholder]="config.placeholder ? (config.placeholder | translate) : ''"
      [maxlength]="config.maxLength"
      [readonly]="config.readonly"
      [disabled]="config.disabled || disabled"
      [autocomplete]="config.autocomplete || 'off'"
      [formControl]="control"
      class="form-control"
      [class.is-invalid]="isInvalid && config.showValidation !== false"
      (blur)="onTouched()"
    />

    <!-- TEXTAREA -->
    <textarea
      *ngIf="config.type === 'textarea'"
      [id]="formControlName"
      [placeholder]="config.placeholder ? (config.placeholder | translate) : ''"
      [maxlength]="config.maxLength"
      [rows]="config.rows || 3"
      [readonly]="config.readonly"
      [disabled]="config.disabled || disabled"
      [formControl]="control"
      class="form-control"
      [class.is-invalid]="isInvalid && config.showValidation !== false"
      (blur)="onTouched()"
    ></textarea>

    <!-- SELECT -->
    <app-select
      *ngIf="config.type === 'select'"
      [inputId]="formControlName || ''"
      [control]="control"
      [disabled]="config.disabled || disabled"
      [options]="config.options || []"
      valueKey="value"
      labelKey="label"
      [emptyLabel]="
        !config.required || config.placeholder
          ? config.placeholder || 'admin.global.select'
          : ''
      "
      [required]="config.required"
      [showValidation]="false"
      panelClass="admin-standard-select-panel"
      (openedChange)="!$event && onTouched()"
    ></app-select>

    <!-- RADIO BUTTONS -->
    <div *ngIf="config.type === 'radio'" class="form-group">
      <div *ngFor="let option of config.options" class="form-group">
        <label
          class="radio-container"
          [attr.for]="formControlName + '_' + option.value"
        >
          {{ option.label | translate }}
          <input
            type="radio"
            [id]="formControlName + '_' + option.value"
            [value]="option.value"
            [formControl]="control"
            [disabled]="config.disabled || disabled"
            (blur)="onTouched()"
          />
          <span class="checkmark"></span>
        </label>
      </div>
    </div>

    <!-- CHECKBOX -->
    <div *ngIf="config.type === 'checkbox'" class="form-check">
      <input
        type="checkbox"
        [id]="formControlName"
        [formControl]="control"
        [disabled]="config.disabled || disabled"
        class="form-check-input"
        (blur)="onTouched()"
      />
      <label class="form-check-label" [attr.for]="formControlName">
        {{ config.placeholder | translate }}
      </label>
    </div>

    <!-- Validation Error Message -->
    <div
      *ngIf="isInvalid && config.showValidation !== false"
      class="invalid-feedback d-block"
    >
      <span>{{ errorMessage | translate: errorMessageParams }}</span>
    </div>

    <!-- Help Text -->
    <div *ngIf="config.helpText" class="form-text text-muted mt-1">
      {{ config.helpText | translate }}
    </div>
  </div>
</div>
